export interface TranslationEntry {
  message: string;
  description: string;
}

const bgCollaboratorsSection: Record<string, TranslationEntry> = {
  "page.settings.collaboratorsDescription": {
    message: "Управлявайте кой може да има достъп и да сътрудничи в тази книга",
    description: "Description for collaborators settings section",
  },
};

export default bgCollaboratorsSection;
